
import $api from '../utils/api.js'

export const Options = {
    strict_loading_mode : false,
    inline:true,
    height: 350,
    deprecation_warnings: false,
    menu : {
        insert: { title: 'Insert', items: 'link media image' },
        format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript | removeformat' },
        table: { title: 'Table', items: 'inserttable tableprops deletetable | cell row column' }
    },
    plugins: [
        'visualblocks visualchars code fullscreen image imagetools link'
    ],
    // imagetools_cors_hosts: ['localhost'],
    // imagetools_credentials_hosts: ['localhost'],
    toolbar: 'insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist',menubar: 'format tools table insert',
    file_picker_types: 'image',
    images_upload_handler: function (blobInfo, success, failure) {
        let formData = new FormData();
        formData.append('vfile', blobInfo.blob());
        $api.post('/media', formData)
            .then(function (res) {
                console.log(res.data.file_url)
                success(res.data.file_url);
            })
            .catch(function (err) {
                failure('HTTP Error: ' + err.message);
            });
    }
}
export const OptionsSimple = {
    strict_loading_mode : false,
    inline:false,
    height: 350,
    deprecation_warnings: false,
    menu : {
        insert: { title: 'Insert', items: 'link media image' },
        format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript | removeformat' },
        table: { title: 'Table', items: 'inserttable tableprops deletetable | cell row column' }
    },
    plugins: [
        'visualblocks visualchars code fullscreen image imagetools link'
    ],
    // imagetools_cors_hosts: ['localhost'],
    // imagetools_credentials_hosts: ['localhost'],
    toolbar: 'insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist',menubar: 'format tools table insert',
    file_picker_types: 'image',
    images_upload_handler: function (blobInfo, success, failure) {
        let formData = new FormData();
        formData.append('vfile', blobInfo.blob());
        $api.post('/media', formData)
            .then(function (res) {
                console.log(res.data.file_url)
                success(res.data.file_url);
            })
            .catch(function (err) {
                failure('HTTP Error: ' + err.message);
            });
    }
}



export default {
    Options,
    OptionsSimple
}